import React from 'react';
import { getSearchResult } from '../../actions/searchAction';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import Header from '../../components/HeaderComponent';
import { connect } from 'react-redux';
import Select from 'react-select';
import { repeatSalesVersionConfig } from '../../config/column_fields';
import axios from 'axios';
import url, { zcommerceUrl } from '../../config';
import { Redirect } from 'react-router-dom';
import { couponDataMapper, mainDataMapper, productDataMapper } from '../../helper/dataMapper';
import '../../styles/addCoupon.css';

class ZunpulseRepeatCreateVersion extends Component {


    constructor() {
        super()
        this.state = {
            couponType: '',
            formData: {},
            mapping: { products: [] },
            userObj: {},
            username:''
        };
    }


    async componentDidMount() {
        try {
            let userObj = JSON.parse(localStorage.getItem("userObj"));
            if (Object.keys(userObj).length > 0) {
              this.setState({
                userObj: userObj,
                username: userObj.username
              })
            }
            const res = await axios.get(`${zcommerceUrl.productPathBackend}product/getProductMapping`);
            const productDataMapping = res?.data?.data;
            const productMapperData = productDataMapper(productDataMapping);
            const obj = { products: productMapperData };
            this.setState({
                mapping: {
                    ...this.state.mapping,
                    ...obj

                }

            })



        } catch (error) {
            console.log('error', error)

        }


    }


    handleSubmit = async (e) => {
        e.preventDefault();
        console.log("form Data", this.state.formData);
        const {startDate , endDate, userFile} = this.state.formData;
        // return;
        try {

            const formData = new FormData();
            formData.append('startDate', startDate)
            formData.append('endDate', endDate)
            formData.append('key',url.apiKey)
            formData.append('email', this.state.username)
            formData.append('file',userFile)
            let apiResponse = await axios.post(`${url.pathBackend}zunpulse/repeatSales/createNewVersionV2`, formData)
            apiResponse = apiResponse.data;
            if(apiResponse && apiResponse.status === "success"){
                this.setState({ formData: {} })
                alert("Banner uploaded Successfully");
                return;
            }
            alert("failed");
                return;


            // // return;
            // let response = await axios.post(`${zcommerceUrl.couponPathBackend}createCouponV2`, apiData);
            // this.setState({
            //     formData: {},
            //     freeProducts:[]
            // })
            // console.log("res", response);
            // response = response.data || {};
            // console.log(response);

            // if (response && response.status === 'success') {
            //     window.location.reload(false);
            //     alert("Coupon Added Successfully");
            //     return;
            // }

            return;

        } catch (error) {
            console.log("errr", error)
            this.setState({ formData: {} })
            alert("Failed");
            return;


        }


    }

   
    handleFileChange = (e) => {
        console.log('event', e);
        let files = e.target.files[0]
        let { name, value } = e.target;
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: files
            }
        })
    }
    handleInputChange = (e) => {
        console.log('event', e);
        let { name, value } = e.target;
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        })
    }





    
    TextTypeInput = ({ name, type, required, min }) => {
        return (
            <input type={type} className="form-control" name={name} onChange={(e) => this.handleInputChange(e)} required={required}></input>
        )
    }


    FileTypeInput = ({ name, type, required, min }) => {
        return (
            <input type={type} className="form-control" name={name} onChange={(e) => this.handleFileChange(e)} required={required}></input>
        )
    }

    InputField = ({ label, name, type, required, optionsName, isMulti }) => {
        let { FileTypeInput, TextTypeInput } = this;
        return (
            <div className="row">
                <label className="col-md-4 mb-4" style={{ fontSize: "17px", fontWeight: "bold" }}>
                    {label}
                </label>
                <div className=" col-md-8">
                    {
                        type == 'file' ? <FileTypeInput
                            name={name}
                            type={type}
                            required={required}
                        /> : <TextTypeInput
                            name={name}
                            type={type}
                            required={required}
                        />
                    }
                </div>
            </div>
        )
    }


    render() {
        let { InputField } = this;

        return (
            <div className='mt-5 mx-auto p-5' style={{border:'1px solid #000'}}>
                <h4 style={{ fontSize: '20px', fontWeight: 'bold' }}>Create RepeatSales New Version</h4>
                <form className='mt-4' onSubmit={(e) => this.handleSubmit(e)}>
                    {
                        repeatSalesVersionConfig.map((config, index) => <InputField key={index} {...config} />)
                    }


                    <button className="btn btn-success float-right mt-1" type="submit">Submit</button>

                </form>


            </div>
        )
    }
}

function mapStateToProps({ }) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ZunpulseRepeatCreateVersion);

